


























import {Component, Vue} from 'vue-property-decorator';
import {認証型} from '@/type/authentication/authentication';
import {tokenModule} from '@/store/authentication/authentication';
import {loginModule} from '@/store/authentication/login';
import {progress} from '@/script/progress';
import {viewEditingStateModule} from '@/store/state/viewEditingState';
import {ValidationResult} from '@/type/validation/result';
import {認証入力バリデータ一覧} from '@/type/authentication/login';

@Component
export default class Logon extends Vue {
  // data
  認証: 認証型 = {
    医療機関コード: '',
    利用者コード: '',
    パスワード: '',
  };

  errorMessage: string | string[] | null = null;

  // computed
  get エラーがある(): boolean {
    return this.errorMessage !== null;
  }

  get アラートメッセージ(): string[] {
    if (this.errorMessage === null) return [];
    if (typeof this.errorMessage === 'string') return [this.errorMessage];
    return this.errorMessage;
  }

  // methods
  async ログイン(): Promise<void> {
    const checker = new ValidationResult(認証入力バリデータ一覧);
    checker.validate(this.認証);
    if (checker.hasErrors) {
      this.errorMessage = checker.getMessages();
      return;
    }

    const ログイン処理 = async (): Promise<void> => {
      await tokenModule.認証する(this.認証)
        .then((response: any) => {
          loginModule.取得する();
          this.$router.push({name: 'home'});
        })
        .catch((error: any) => {
          this.errorMessage = error.data.message;
        });
    };

    await progress(ログイン処理);
  }

  // lifecycle hooks
  created(): void {
    viewEditingStateModule.初期化する();
  }
}
